module.exports = __webpack_public_path__ + "static/media/more@2x.bdf65bd0.png";